import store from '../store/index'
import _ from 'lodash'
let translations = require('./Translations')

let computeCaption = translations.TranslationsUtils.methods.computeCaption
export const QuestionUtils = {
  methods: {
    checkIfAnswer (placeholder, questionCode) {
      // placeholder can either be answerCode for multichoice or combobox
      // or it can be value for the other types
      let questionMap = store.state.questionsMap
      if ((questionMap[questionCode]['type'] === 'Multichoice' || questionMap[questionCode]['type'] === 'Multichoice Toggle') && questionMap[questionCode]['multiple'] && questionMap[questionCode]['multiple'].length !== 0) {
        let answerId = this.getAnswerId(placeholder, store.state.questionsMap[questionCode]['answers'])
        return questionMap[questionCode]['multiple'].findIndex((element) => {
          return element === questionMap[questionCode]['answers'][answerId]['name']
        }) !== -1
      } else if ((questionMap[questionCode]['type'] === 'Combobox' || questionMap[questionCode]['type'] === 'Combobox Toggle') && typeof questionMap[questionCode]['value'] === 'object' && Object.keys(questionMap[questionCode]['value']).length) {
        let answerId = this.getAnswerId(placeholder, store.state.questionsMap[questionCode]['answers'])
        return questionMap[questionCode]['value']['answer_id'] === answerId
      } else if ((questionMap[questionCode]['type'] !== 'Combobox' || questionMap[questionCode]['type'] === 'Combobox Toggle') && questionMap[questionCode]['type'] !== 'Multichoice' && questionMap[questionCode]['type'] !== 'Multichoice Toggle') {
        return questionMap[questionCode]['value'] === placeholder
      } else {
        return false
      }
    },
    hideEveryAnswerBesides (answerCode, questionCode) {
      let answerId = this.getAnswerId(answerCode, store.state.questionsMap[questionCode]['answers'])
      let question = store.state.questionsMap[questionCode]
      let id
      for (id in question['answers']) {
        if (question['answers'][id] !== answerId) {
          question['answers'][id]['available'] = false
        }
      }
    },
    showEveryAnswerBesides (answerCode, questionCode) {
      let answerId = this.getAnswerId(answerCode, store.state.questionsMap[questionCode]['answers'])
      let question = store.state.questionsMap[questionCode]
      let id
      for (id in question['answers']) {
        question['answers'][id]['available'] = question['answers'][id] !== answerId
      }
    },
    showEveryAnswer (questionCode) {
      let question = store.state.questionsMap[questionCode]
      let id
      for (id in question['answers']) {
        question['answers'][id]['available'] = true
      }
    },
    hideEveryAnswer (questionCode) {
      let question = store.state.questionsMap[questionCode]
      let id
      for (id in question['answers']) {
        question['answers'][id]['available'] = false
      }
    },
    hideAnswer (answerCode, questionCode) {
      let answerId = this.getAnswerId(answerCode, store.state.questionsMap[questionCode]['answers'])
      store.state.questionsMap[questionCode]['answers'][answerId]['available'] = false
      this.checkVisibilityOfQuestion(store.state.questionsMap[questionCode])
    },
    hideQuestion (questionCode) {
      store.state.questionsMap[questionCode]['available'] = false
      this.hideEveryAnswer(questionCode)
    },
    showQuestion (questionCode) {
      store.state.questionsMap[questionCode]['available'] = true
      this.showEveryAnswer(questionCode)
    },
    showAnswer (answerCode, questionCode) {
      let answerId = this.getAnswerId(answerCode, store.state.questionsMap[questionCode]['answers'])
      store.state.questionsMap[questionCode]['answers'][answerId]['available'] = true
      this.checkVisibilityOfQuestion(store.state.questionsMap[questionCode])
    },
    checkVisibilityOfQuestion (question) {
      if (!question['answers'] || question['answers'] === [] || question['answers'].length === 0) {
        question['available'] = true
        return true
      }
      let answersArray = question['answers']
      let answersId
      let available = false
      for (answersId in answersArray) {
        if (answersArray[answersId]['available']) {
          available = true
        }
      }
      question['available'] = available
      return question['available']
    },
    firstTraversal (questionsArray) {
      let rules = store.state.questionsRules
      let questionMap = store.state.questionsMap
      let questionsId
      for (questionsId in questionsArray) {
        if (_.get(questionsArray[questionsId], 'code')) {
          questionMap[questionsArray[questionsId]['code']] = questionsArray[questionsId]
        }
        if (questionsArray[questionsId]['action_rule'] !== '' && questionsArray[questionsId]['action_rule'] !== undefined && questionsArray[questionsId]['action_rule']) {
          rules.expression += questionsArray[questionsId]['action_rule']
        }
        if (questionsArray[questionsId]['answers'] !== undefined && questionsArray[questionsId]['answers'] !== [] && questionsArray[questionsId]['answers'] !== {} && questionsArray[questionsId]['answers']) {
          let answersArray = questionsArray[questionsId]['answers']
          let answersId
          for (answersId in answersArray) {
            if (answersArray[answersId]['questions'] !== undefined && answersArray[answersId]['questions'] !== [] && answersArray[answersId]['questions'] !== {} && answersArray[answersId]['questions']) {
              this.firstTraversal(answersArray[answersId]['questions'])
            }
          }
        }
      }
    },
    ageInterval (lowerGap, higherGap) {
      let higherGapDate = new Date()
      let lowerGapDate = new Date()
      lowerGapDate.setFullYear(lowerGapDate.getFullYear() - lowerGap)
      higherGapDate.setFullYear(higherGapDate.getFullYear() - higherGap)
      let dobDate = new Date(store.state.user.dob)
      return dobDate <= lowerGapDate && dobDate >= higherGapDate
    },
    validateQuestions (questions, validator, selectedBill = 'main') {
      let MultichoiceTypes = ['Multichoice', 'Multichoice Toggle']
      if (typeof questions === 'object') {
        // transform questions nested object in array of objects to loop through
        questions = Object.values(questions)
      }
      let answerId
      for (let question of questions) {
        // check to see if the question does belong to the desired section (selectedBill)
        if (question['group_bill_type'] === selectedBill) {
          if (question['available'] === false) {
            // a question is not visible by a rule
            if (store.state.questionsErrorArray.includes(question['id'])) {
              let index = store.state.questionsErrorArray.indexOf(question['id'])
              if (index !== -1) {
                store.state.questionsErrorArray.splice(index, 1)
              }
            }
            continue
          }
          if (MultichoiceTypes.includes(question['type'])) {
            // transfer from 'multiple' array to the value to validate
            question['value'] = question['multiple']
          }
          if (question['id'] && question['value']) {
            if (typeof question['value'] === 'string' && question['value'] !== '') {
              if (store.state.questionsErrorArray.includes(question['id'])) {
                let index = store.state.questionsErrorArray.indexOf(question['id'])
                if (index !== -1) {
                  store.state.questionsErrorArray.splice(index, 1)
                }
              }
              continue
            }
            if (typeof question['value'] === 'object') {
              if (Object.keys(question['value']).length === 0) {
                // if we do not have any entry, it's an error and it needs to be shown and we return the callback to the upper recursion level
                if (!store.state.questionsErrorArray.includes(question['id'])) {
                  store.state.questionsErrorArray.push(question['id'])
                }
                validator = false
                return validator
              }
              answerId = question['value']['answer_id']
              if (question['value']['answer_id']) {
                this.addToIcdArray(question, answerId)
              }
              if (MultichoiceTypes.includes(question['type'])) {
                if (question['value'].length === 0) {
                  // if we do not have any entry, it's an error and it needs to be shown and we return the callback to the upper recursion level
                  if (!store.state.questionsErrorArray.includes(question['id'])) {
                    store.state.questionsErrorArray.push(question['id'])
                  }
                  validator = false
                  return validator
                }
                // loop through each question value, get their respective id then add their respective
                // icds to the list, then look for deeper level of recursion
                question['value'].forEach(inArrayAnswer => {
                  let answerId = inArrayAnswer
                  let functionFind = function (element) {
                    return element['name'] === answerId
                  }
                  let answersArray = Object.values(question['answers'])
                  answerId = answersArray.find(functionFind)['id']
                  this.addToIcdArray(question, answerId)
                  if (question['answers'][answerId] && question['answers'][answerId]['questions']) {
                    if (store.state.questionsErrorArray.includes(question['id'])) {
                      let index = store.state.questionsErrorArray.indexOf(question['id'])
                      if (index !== -1) {
                        store.state.questionsErrorArray.splice(index, 1)
                      }
                    }
                    validator = this.validateQuestions(question['answers'][answerId]['questions'], validator)
                  }
                })
              }
              if (question['answers'][answerId] && question['answers'][answerId]['questions']) {
                if (store.state.questionsErrorArray.includes(question['id'])) {
                  let index = store.state.questionsErrorArray.indexOf(question['id'])
                  if (index !== -1) {
                    store.state.questionsErrorArray.splice(index, 1)
                  }
                }
                validator = this.validateQuestions(question['answers'][answerId]['questions'], validator)
              }
            }
          } else {
            if (!store.state.questionsErrorArray.includes(question['id'])) {
              store.state.questionsErrorArray.push(question['id'])
            }
            validator = false
            return validator
          }
        }
      }
      return validator
    },
    addToIcdArray (question, answerId) {
      if (question['answers'][answerId]['icd_ids'].length) {
        this.$store.state.icdCodes.push(question['answers'][answerId]['icd_ids'])
      }
    },
    getQuestionDescription (question) {
      let description = ''
      if (((question['type'] === 'Multichoice' || question['type'] === 'Multichoice Toggle') && question['multiple'] && question['multiple'].length === 0) || question['value'] === '' || question['value'] === undefined || question['value'] === null) {
        return computeCaption(question['info'], store.state.lang.value.toLowerCase()) || ''
      } else if ((question['type'] === 'Multichoice' || question['type'] === 'Multichoice Toggle') && question['multiple'] && question['multiple'].length !== 0) {
        let id
        for (id in question['multiple']) {
          let answerIds
          for (answerIds in question['answers']) {
            if (question['answers'][answerIds]['name'] === question['multiple'][id]) {
              if (question['answers'][answerIds]['info'] && question['answers'][answerIds]['info'] !== null) {
                description += question['answers'][answerIds]['info'] + ' '
              }
            }
          }
        }
        if (description !== '') {
          return computeCaption(description, store.state.lang.value.toLowerCase()) || ''
        } else {
          return computeCaption(question['info'], store.state.lang.value.toLowerCase()) || ''
        }
      } else if ((question['type'] === 'Combobox' || question['type'] === 'Combobox Toggle') && typeof question['value'] === 'object' && Object.keys(question['value']).length) {
        if (computeCaption(question['answers'][question['value']['answer_id']]['info'], store.state.lang.value.toLowerCase()) !== '') {
          return computeCaption(question['answers'][question['value']['answer_id']]['info'], store.state.lang.value.toLowerCase()) || ''
        } else {
          return computeCaption(question['info'], store.state.lang.value.toLowerCase()) || ''
        }
      } else {
        return computeCaption(question['info'], store.state.lang.value.toLowerCase()) || ''
      }
    },
    computeQuestionAnswersPrice (questions, amount, priceBreakdown) {
      if (typeof questions === 'object') {
        questions = Object.values(questions)
      }
      let answerId
      for (let question of questions) {
        if (question['available'] === false) {
          continue
        }
        if (question['type'] === 'Multichoice' || question['type'] === 'Multichoice Toggle') {
          question['value'] = question['multiple']
        }
        if (question['id'] && question['value']) {
          if (typeof question['value'] === 'string' && question['value'] !== '') {
            continue
          }
          if (typeof question['value'] === 'object') {
            if (!Object.keys(question['value']).length) {
              continue
            }
            answerId = question['value']['answer_id']
            if (question['value']['answer_id']) {
              if (question['answers'][answerId]['strikethrough'] === false && question['answers'][answerId]['price'] !== undefined &&
                  question['answers'][answerId]['price'] && question['answers'][answerId]['price'].length !== null &&
                  question['answers'][answerId]['price'].length && parseFloat(question['answers'][answerId]['price']) !== 0) {
                amount += parseFloat(question['answers'][answerId]['price'])
                priceBreakdown.push({'label': question['name'], 'value': question['answers'][answerId]['name'], 'price': parseFloat(question['answers'][answerId]['price'])})
              } else if (question['answers'][answerId]['strikethrough'] === true && question['answers'][answerId]['price'] !== undefined &&
                question['answers'][answerId]['price'] && question['answers'][answerId]['price'].length !== null &&
                question['answers'][answerId]['price'].length && parseFloat(question['answers'][answerId]['price']) !== 0) {
                priceBreakdown.push({'label': store.state.crossAnswerPriceLabel, 'value': question['answers'][answerId]['name'], 'price': '-'})
              }
            }
            if (question['type'] === 'Multichoice' || question['type'] === 'Multichoice Toggle') {
              if (!question['value'].length) {
                continue
              }
              if (_.get(question, 'discount', null) && question['discount'].length) {
                let answerNo = 0
                for (let aId of question['multiple_ids']) {
                  if (question['answers'][aId]['strikethrough'] === false) {
                    answerNo++
                  } else {
                    priceBreakdown.push({'label': store.state.crossAnswerPriceLabel, 'value': question['answers'][aId]['name'], 'price': '-'})
                  }
                }
                // let answerNo = question['value'].length
                if (answerNo !== 0) {
                  let functionFindPriceAnswerN = function (element) {
                    return parseFloat(element['count_answers']) === answerNo
                  }
                  let correctPrice = question['discount'].find(functionFindPriceAnswerN)
                  amount += parseFloat(correctPrice['price'])
                  priceBreakdown.push({
                    'label': question['name'],
                    'value': String(question['value']),
                    'price': parseFloat(correctPrice['price'])
                  })
                }
              }
              question['value'].forEach(inArrayAnswer => {
                let answerId = inArrayAnswer
                let functionFind = function (element) {
                  return element['name'] === answerId && element['strikethrough'] === false
                }
                let answersArray = Object.values(question['answers'])
                answerId = answersArray.find(functionFind)
                if (answerId !== undefined) {
                  answerId = answerId['id']
                  if (!(_.get(question, 'discount', null) && question['discount'].length)) {
                    if (question['answers'][answerId]['strikethrough'] === false && question['answers'][answerId]['price'] !== undefined &&
                        question['answers'][answerId]['price'] !== null && question['answers'][answerId]['price'].length &&
                        parseFloat(question['answers'][answerId]['price']) !== 0) {
                      amount += parseFloat(question['answers'][answerId]['price'])
                      priceBreakdown.push({
                        'label': question['name'],
                        'value': question['answers'][answerId]['name'],
                        'price': parseFloat(question['answers'][answerId]['price'])
                      })
                    } else if (question['answers'][answerId]['strikethrough'] === true && question['answers'][answerId]['price'] !== undefined &&
                              question['answers'][answerId]['price'] !== null && question['answers'][answerId]['price'].length &&
                              parseFloat(question['answers'][answerId]['price']) !== 0) {
                      priceBreakdown.push({
                        'label': store.state.crossAnswerPriceLabel,
                        'value': question['answers'][answerId]['name'],
                        'price': '-'
                      })
                    }
                  }
                  if (question['answers'][answerId] && question['answers'][answerId]['questions']) {
                    let compute = this.computeQuestionAnswersPrice(question['answers'][answerId]['questions'], amount, priceBreakdown)
                    amount = compute.amount
                    priceBreakdown = compute.paymentBreakdown
                  }
                }
              })
            }
            if (question['answers'][answerId] && question['answers'][answerId]['questions']) {
              let compute = this.computeQuestionAnswersPrice(question['answers'][answerId]['questions'], amount, priceBreakdown)
              amount = compute.amount
              priceBreakdown = compute.paymentBreakdown
            }
          }
        } else {
          return {'amount': amount, 'paymentBreakdown': priceBreakdown}
        }
      }
      return {'amount': amount, 'paymentBreakdown': priceBreakdown}
    },
    checkIfMainSectionIsShown (questionsO) {
      let show = false
      let questions = questionsO
      if (typeof questions === 'object') {
        questions = Object.values(questions)
      }
      for (let question of questions) {
        if (question['group_bill_type'] === 'main' && question['available'] === true) {
          show = true
        }
      }
      return show
    },
    getAnswerId (answerCode, answerArray) {
      let id
      for (id in answerArray) {
        if (answerArray[id]['code'] === answerCode.toString()) {
          return id
        }
      }
    },
    strikethroughAnswer (answerCode, questionCode) {
      let question = store.state.questionsMap[questionCode]
      let answerId = this.getAnswerId(answerCode, question['answers'])
      // console.log(question['answers'][answerId])
      question['answers'][answerId]['strikethrough'] = true
    },
    unstrikeAnswer (answerCode, questionCode) {
      let question = store.state.questionsMap[questionCode]
      let answerId = this.getAnswerId(answerCode, question['answers'])
      // console.log(question['answers'][answerId])
      question['answers'][answerId]['strikethrough'] = false
    },
    setQuestionDisclaimer (text, questionCode) {
      let question = store.state.questionsMap[questionCode]
      question['info'] = computeCaption(text, store.state.lang.value.toLowerCase()) || question['info']
    },
    setQuestionAnswerDisclaimer (text, answerCode, questionCode) {
      let question = store.state.questionsMap[questionCode]
      let answerId = this.getAnswerId(answerCode, question['answers'])
      question['answers'][answerId]['info'] = computeCaption(text, store.state.lang.value.toLowerCase()) || question['answers'][answerId]['info']
    },
    checkDisabledDateQuestion (time, question) {
      if (question.disabledOlderDates === true && question.disabledOlderDates !== undefined) {
        return time.getTime() < (Date.now() - 86400000)
      }
      if (question.disabledOlderDates === false && question.disabledOlderDates !== undefined && question.disabledFutureDates === undefined) {
        if (time.getTime() < (Date.now() - 86400000)) {
          return false
        }
      }
      if (question.disabledFutureDates === true && question.disabledFutureDates !== undefined) {
        return time.getTime() > Date.now()
      }
      if (question.disabledFutureDates === false && question.disabledFutureDates !== undefined) {
        if (time.getTime() >= Date.now()) {
          return false
        }
      }
    },
    disableOlderDates (questionCode) {
      let question = store.state.questionsMap[questionCode]
      question['disabledOlderDates'] = true
    },
    enableOlderDates (questionCode) {
      let question = store.state.questionsMap[questionCode]
      question['disabledOlderDates'] = false
    },
    disableFutureDates (questionCode) {
      let question = store.state.questionsMap[questionCode]
      question['disabledFutureDates'] = true
    },
    enableFutureDates (questionCode) {
      let question = store.state.questionsMap[questionCode]
      question['disabledFutureDates'] = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/Questions.js